import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon, EyeOffIcon } from 'lucide-react';
export function DiagnosticoSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-brand-black relative border-t border-white/5" data-id="element-129">
      {/* Subtle background glow */}
      <div className="absolute top-0 right-1/4 w-64 h-64 bg-red-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-130" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-131">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-16" data-id="element-132">
          <motion.h2 variants={itemVariants} className="font-heading text-brand-yellow text-sm md:text-base tracking-[0.3em] uppercase mb-4" data-id="element-133">
            El Diagnóstico
          </motion.h2>
          <motion.h3 variants={itemVariants} className="font-heading text-3xl md:text-5xl font-bold text-white" data-id="element-134">
            ¿Por qué tu negocio de control de plagas no crece?
          </motion.h3>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-135">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="group bg-brand-dark border border-white/5 p-10 rounded-xl hover:border-red-500/30 transition-all duration-500 relative overflow-hidden" data-id="element-136">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-137" />

            <div className="w-14 h-14 rounded-full bg-red-950/50 flex items-center justify-center mb-6 border border-red-900/50 group-hover:scale-110 transition-transform duration-500" data-id="element-138">
              <TrendingDownIcon className="w-6 h-6 text-red-500" data-id="element-139" />
            </div>

            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-140">
              Crecimiento Lento
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-141">
              Solo haces trabajos de $40 mensuales. Necesitas contratos grandes
              de fumigación comercial para escalar verdaderamente tu negocio.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="group bg-brand-dark border border-white/5 p-10 rounded-xl hover:border-red-500/30 transition-all duration-500 relative overflow-hidden" data-id="element-142">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-143" />

            <div className="w-14 h-14 rounded-full bg-red-950/50 flex items-center justify-center mb-6 border border-red-900/50 group-hover:scale-110 transition-transform duration-500" data-id="element-144">
              <EyeOffIcon className="w-6 h-6 text-red-500" data-id="element-145" />
            </div>

            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-146">
              Invisibilidad en el Barrio
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-147">
              Nadie sabe que eres el mejor porque tu marketing es ruidoso, poco
              profesional y no llega a las personas correctas en el momento
              exacto.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}